export const DECISION_FLOW_TYPES = {
  SPECIALIST_PORTAL: 'SPECIALIST_PORTAL',
  SPECIALIST_PORTAL_DRAFT: 'SPECIALIST_PORTAL_DRAFT',
  SPECIALIST_PORTAL_TEMPLATE: 'SPECIALIST_PORTAL_TEMPLATE',
  SELF_HELP: 'SELF_HELP',
};

export const DECISION_NODE_ACTIONS = {
  EXPERT_QUESTION: 'EXPERT_QUESTION',
  SEND_MACRO: 'SEND_MACRO',
  SEND_MACRO_AND_CONTINUE: 'SEND_MACRO_AND_CONTINUE',
  ESCALATE_TO_SPECIALISTS: 'ESCALATE_TO_SPECIALISTS',
  ESCALATE_TO_PARTNER: 'ESCALATE_TO_PARTNER',
  ESCALATE_TO_PARTNER_CUSTOM_DEPARTMENT: 'ESCALATE_TO_PARTNER_CUSTOM_DEPARTMENT',
  EXPERT_LINK_QUESTION: 'EXPERT_LINK_QUESTION',
  SELECT_ORDER_AND_LINE_ITEMS: 'SELECT_ORDER_AND_LINE_ITEMS', // vanilla select with no processing (no_search_results, next)
  SELECT_ORDER: 'SELECT_ORDER',
  INSTRUCTIONS: 'INSTRUCTIONS',
  MACRO_SNIPPET: 'MACRO_SNIPPET',
  CANCEL_AMAZON_ORDER_AND_SEND_MACRO: 'CANCEL_AMAZON_ORDER_AND_SEND_MACRO',
  CANCEL_AND_REFUND_ORDER_ITEMS_THEN_SEND_MACRO: 'CANCEL_AND_REFUND_ORDER_ITEMS_THEN_SEND_MACRO',
  CANCEL_AND_REFUND_OR_DISCOUNT_ORDER_ITEMS_THEN_SEND_MACRO:
    'CANCEL_AND_REFUND_OR_DISCOUNT_ORDER_ITEMS_THEN_SEND_MACRO',
  CANCEL_SUBSCRIPTION_THEN_SEND_MACRO: 'CANCEL_SUBSCRIPTION_THEN_SEND_MACRO',
  CHANGE_ADDRESS_FOR_ORDER_OR_SUBSCRIPTION: 'CHANGE_ADDRESS_FOR_ORDER_OR_SUBSCRIPTION',
  CHOOSE_SUBSCRIPTION_FOR_CANCELLATION: 'CHOOSE_SUBSCRIPTION_FOR_CANCELLATION',
  SELECT_SUBSCRIPTION: 'SELECT_SUBSCRIPTION',
  CHOOSE_SUBSCRIPTION_OR_ORDER_FOR_ADDRESS_CHANGE: 'CHOOSE_SUBSCRIPTION_OR_ORDER_FOR_ADDRESS_CHANGE',
  COPY_TRACKING_LINK: 'COPY_TRACKING_LINK',
  CONFIRM_LAST_MILE_REPLACEMENT_ORDER: 'CONFIRM_LAST_MILE_REPLACEMENT_ORDER',
  DELIVERY_QUESTION: 'DELIVERY_QUESTION',
  REPLACE_ORDER_WITH_COUPON_THEN_SEND_MACRO: 'REPLACE_ORDER_WITH_COUPON_THEN_SEND_MACRO',
  SELECT_AMAZON_ORDER: 'SELECT_AMAZON_ORDER',
  SELECT_COUPON_CODE: 'SELECT_COUPON_CODE',
  SELECT_DISCOUNT_PERIOD: 'SELECT_DISCOUNT_PERIOD',
  SELECT_DISCOUNT_PERIOD_FOR_ITEMS: 'SELECT_DISCOUNT_PERIOD_FOR_ITEMS',
  SELECT_ORDER_AND_LINE_ITEMS_WITH_NO_RESULT_MACRO: 'SELECT_ORDER_AND_LINE_ITEMS_WITH_NO_RESULT_MACRO',
  SELECT_ORDER_AND_LINE_ITEMS_YETI_CANCEL: 'SELECT_ORDER_AND_LINE_ITEMS_YETI_CANCEL',
  SELECT_ORDER_FOR_CANCELLATION_AND_REFUND: 'SELECT_ORDER_FOR_CANCELLATION_AND_REFUND',
  SELECT_ORDER_ITEMS_FOR_CANCELLATION_AND_REFUND: 'SELECT_ORDER_ITEMS_FOR_CANCELLATION_AND_REFUND',
  SELECT_ORDER_RBI_PARTIAL_REFUND: 'SELECT_ORDER_RBI_PARTIAL_REFUND',
  SELECT_ORDER_RBI_FULL_REFUND: 'SELECT_ORDER_RBI_FULL_REFUND',
  SELECT_ORDER_RBI_COUPON_ISSUE: 'SELECT_ORDER_RBI_COUPON_ISSUE',
  SELECT_ITEMS_RBI_COUPON_ISSUE: 'SELECT_ITEMS_RBI_COUPON_ISSUE',
  SELECT_ORDER_RBI_LOYALTY_POINTS_ISSUE: 'SELECT_ORDER_RBI_LOYALTY_POINTS_ISSUE',
  RBI_ISSUE_LOYALTY_POINTS_THEN_SEND_MACRO: 'RBI_ISSUE_LOYALTY_POINTS_THEN_SEND_MACRO',
  RBI_ISSUE_LOYALTY_POINTS_AND_REFUND_THEN_SEND_MACRO: 'RBI_ISSUE_LOYALTY_POINTS_AND_REFUND_THEN_SEND_MACRO',
  SELECT_ORDER_TO_DETECT_CANCELLATIONS: 'SELECT_ORDER_TO_DETECT_CANCELLATIONS',
  SELECT_ORDER_AND_LINE_ITEMS_FOR_PRICE_MATCH: 'SELECT_ORDER_AND_LINE_ITEMS_FOR_PRICE_MATCH',
  SELECT_REFUND_REASON: 'SELECT_REFUND_REASON',
  SELECT_CANCEL_OR_REFUND_REASON: 'SELECT_CANCEL_OR_REFUND_REASON',
  SELECT_REFUND_REASON_FOR_LAST_MILE: 'SELECT_REFUND_REASON_FOR_LAST_MILE',
  SELECT_REASON_FOR_LAST_MILE: 'SELECT_REASON_FOR_LAST_MILE',
  SELECT_COUPON_REASON: 'SELECT_COUPON_REASON',
  SELECT_RBI_REFUND_AND_COUPON_REASON: 'SELECT_RBI_REFUND_AND_COUPON_REASON',
  SEND_CONSTRUCTED_MACRO: 'SEND_CONSTRUCTED_MACRO',
  SEND_MACRO_AND_CHANGE_SUBSCRIPTION_FREQUENCY: 'SEND_MACRO_AND_CHANGE_SUBSCRIPTION_FREQUENCY',
  SEND_MACRO_AND_CANCEL_SUBSCRIPTION: 'SEND_MACRO_AND_CANCEL_SUBSCRIPTION',
  SEND_MACRO_AND_CANCEL_SUBSCRIPTION_WITH_CURRENT_ORDER: 'SEND_MACRO_AND_CANCEL_SUBSCRIPTION_WITH_CURRENT_ORDER',
  SEND_MACRO_GIVE_FREESHIP_CODE: 'SEND_MACRO_GIVE_FREESHIP_CODE',
  SEND_MACRO_AND_REFUND_ITEMS: 'SEND_MACRO_AND_REFUND_ITEMS',
  SEND_MACRO_GIVE_STORE_CREDIT: 'SEND_MACRO_GIVE_STORE_CREDIT',
  SEND_MACRO_AND_REFUND_ITEMS_RBI: 'SEND_MACRO_AND_REFUND_ITEMS_RBI',
  SEND_MACRO_AND_REFUND_FULL_ORDER_RBI: 'SEND_MACRO_AND_REFUND_FULL_ORDER_RBI',
  SEND_CONSTRUCTED_MACRO_AND_PARTIAL_REFUND_ITEMS: 'SEND_CONSTRUCTED_MACRO_AND_PARTIAL_REFUND_ITEMS',
  SEND_MACRO_AND_CONFIRM_ADDRESS_CHANGE: 'SEND_MACRO_AND_CONFIRM_ADDRESS_CHANGE',
  SET_CUSTOMER_GROUP: 'SET_CUSTOMER_GROUP',
  RBI_ISSUE_COUPON_THEN_SEND_MACRO: 'RBI_ISSUE_COUPON_THEN_SEND_MACRO',
  RBI_ISSUE_COUPON_AND_REFUND_THEN_SEND_MACRO: 'RBI_ISSUE_COUPON_AND_REFUND_THEN_SEND_MACRO',
  RBI_SEARCH_GIFT_CARD: 'RBI_SEARCH_GIFT_CARD',
  RBI_TRANSFER_GIFT_CARD_FUNDS: 'RBI_TRANSFER_GIFT_CARD_FUNDS',
  SELECT_ORDER_FOR_SHIPPING_REFUND: 'SELECT_ORDER_FOR_SHIPPING_REFUND',
  RBI_UPDATE_FIELD_WITH_STORE_ID: 'RBI_UPDATE_FIELD_WITH_STORE_ID',
  REFUND_SHIPPING_THEN_SEND_MACRO: 'REFUND_SHIPPING_THEN_SEND_MACRO',
  CHECK_ORDER_DATE_PERIOD: 'CHECK_ORDER_DATE_PERIOD',
  PARTIALLY_REFUND_ITEMS_THEN_SEND_MACRO: 'PARTIALLY_REFUND_ITEMS_THEN_SEND_MACRO',
  SELECT_ORDER_ITEMS_FOR_PARTIAL_REFUND: 'SELECT_ORDER_ITEMS_FOR_PARTIAL_REFUND',
  REVOLVE_SELECT_ORDER_FOR_CANCEL: 'REVOLVE_SELECT_ORDER_FOR_CANCEL',
  REVOLVE_ORDER_SHIP_TO_COUNTRY: 'REVOLVE_ORDER_SHIP_TO_COUNTRY',
  BUSINESS_DAY_CALCULATOR: 'BUSINESS_DAY_CALCULATOR',
  SEARCH_RETURNS: 'SEARCH_RETURNS',
  REPLACE_ITEM_THEN_SEND_MACRO: 'REPLACE_ITEM_THEN_SEND_MACRO',
  CANCEL_AND_REFUND_SELECTED_ITEMS_THEN_SEND_MACRO: 'CANCEL_AND_REFUND_SELECTED_ITEMS_THEN_SEND_MACRO',
  REFUND_SELECTED_ITEMS_THEN_SEND_MACRO: 'REFUND_SELECTED_ITEMS_THEN_SEND_MACRO',
  REPLACE_SELECTED_ITEMS_THEN_SEND_MACRO: 'REPLACE_SELECTED_ITEMS_THEN_SEND_MACRO',
  SELECT_ITEMS_FOR_CANCELLATION_PROCESSING: 'SELECT_ITEMS_FOR_CANCELLATION_PROCESSING',
  SELECT_ITEMS_FOR_REFUND_PROCESSING: 'SELECT_ITEMS_FOR_REFUND_PROCESSING',
  SELECT_ITEMS_FOR_CANCEL_AND_REFUND_PROCESSING: 'SELECT_ITEMS_FOR_CANCEL_AND_REFUND_PROCESSING',
  CHANGE_ORDER_ADDRESS_THEN_SEND_MACRO: 'CHANGE_ORDER_ADDRESS_THEN_SEND_MACRO',
  SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT: 'SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT',
  REINSTATE_ACCOUNT_THEN_SEND_MACRO: 'REINSTATE_ACCOUNT_THEN_SEND_MACRO',
  SHOW_IMAGES_OF_SELECTED_ITEMS: 'SHOW_IMAGES_OF_SELECTED_ITEMS',
  RBI_SELECT_POINTS_REASON: 'RBI_SELECT_POINTS_REASON',
  CHANGE_SHIPPING_DATE_THEN_SEND_MACRO: 'CHANGE_SHIPPING_DATE_THEN_SEND_MACRO',
  PREVIOUS_CONVERSATIONS_CHECK: 'PREVIOUS_CONVERSATIONS_CHECK',
  SUBMIT_PARTNER_REACH_OUT: 'SUBMIT_PARTNER_REACH_OUT',
  ORDER_SUBTOTAL_CALCULATOR: 'ORDER_SUBTOTAL_CALCULATOR',
  PROCESS_RETURN_THEN_SEND_MACRO: 'PROCESS_RETURN_THEN_SEND_MACRO',
  CANCEL_RETURN_THEN_SEND_MACRO: 'CANCEL_RETURN_THEN_SEND_MACRO',
  ADD_ORDER_TO_RETURN_ALLOWLIST_THEN_SEND_MACRO: 'ADD_ORDER_TO_RETURN_ALLOWLIST_THEN_SEND_MACRO',
  PROCESSING: 'PROCESSING',
  EXPERT_QUESTION_NUMBER_OF_CYCLES: 'EXPERT_QUESTION_NUMBER_OF_CYCLES',
  CONFIGURABLE_NODE: 'CONFIGURABLE_NODE',
  SELECT_CUSTOMER: 'SELECT_CUSTOMER',
  RBI_UPDATE_CUSTOMER_BIRTHDAY_THEN_SEND_MACRO: 'RBI_UPDATE_CUSTOMER_BIRTHDAY_THEN_SEND_MACRO',
  SEND_CUSTOMER_PASSWORD_RESET: 'SEND_CUSTOMER_PASSWORD_RESET',
  VALIDATE_CHEGG_BOOK_ISSUES: 'VALIDATE_CHEGG_BOOK_ISSUES',
  CHEGG_HANDLE_BOOK_ISSUES_THEN_SEND_MACRO: 'CHEGG_HANDLE_BOOK_ISSUES_THEN_SEND_MACRO',
  RBI_STORE_LOCATION_SEARCH: 'RBI_STORE_LOCATION_SEARCH',
  SELECT_ACCOUNT: 'SELECT_ACCOUNT',
  SEARCH_ACCOUNT_PURCHASE_HISTORY: 'SEARCH_ACCOUNT_PURCHASE_HISTORY',
  SELECT_PRODUCT: 'SELECT_PRODUCT',
  ADD_CUSTOMER_DETAILS_FOR_ITEM_REPLACEMENT: 'ADD_CUSTOMER_DETAILS_FOR_ITEM_REPLACEMENT',
  SEND_MACRO_AND_REPLACE_ITEM_FROM_PRODUCT_SEARCH: 'SEND_MACRO_AND_REPLACE_ITEM_FROM_PRODUCT_SEARCH',
  CONFIGURABLE_CALCULATION_NODE: 'CONFIGURABLE_CALCULATION_NODE',
  ML_AGENT_ASSIST: 'ML_AGENT_ASSIST',
  ML_AGENT_ASSIST_SEND_MACRO: 'ML_AGENT_ASSIST_SEND_MACRO',
  ML_TROUBLESHOOTING_AGENT_ASSIST: 'ML_TROUBLESHOOTING_AGENT_ASSIST',
  ADD_TAGS_TO_ORDER: 'ADD_TAGS_TO_ORDER',
  UPDATE_TICKET_FIELD: 'UPDATE_TICKET_FIELD',
  PAUSE_SUBSCRIPTION: 'PAUSE_SUBSCRIPTION',
  COPILOT: 'COPILOT',
};

// These actions need special navigation handling
// Adding a node to this array will change how back buttons
// clicks are handled
export const DECISION_TREE_SPINNER_ACTIONS = [
  DECISION_NODE_ACTIONS.PROCESSING,
  DECISION_NODE_ACTIONS.RBI_UPDATE_FIELD_WITH_STORE_ID,
];

export const DECISION_NODE_SEND_MACRO_ACTIONS = [
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_CHANGE_SUBSCRIPTION_FREQUENCY,
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_CANCEL_SUBSCRIPTION,
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_CANCEL_SUBSCRIPTION_WITH_CURRENT_ORDER,
  DECISION_NODE_ACTIONS.SEND_CONSTRUCTED_MACRO,
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_REFUND_ITEMS,
  DECISION_NODE_ACTIONS.SEND_MACRO_GIVE_STORE_CREDIT,
  DECISION_NODE_ACTIONS.SEND_MACRO_GIVE_FREESHIP_CODE,
  DECISION_NODE_ACTIONS.SEND_CONSTRUCTED_MACRO_AND_PARTIAL_REFUND_ITEMS,
  DECISION_NODE_ACTIONS.CANCEL_SUBSCRIPTION_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.CANCEL_AMAZON_ORDER_AND_SEND_MACRO,
  DECISION_NODE_ACTIONS.REPLACE_ORDER_WITH_COUPON_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.CANCEL_AND_REFUND_ORDER_ITEMS_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.CANCEL_AND_REFUND_OR_DISCOUNT_ORDER_ITEMS_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_REFUND_ITEMS_RBI,
  DECISION_NODE_ACTIONS.SEND_MACRO_AND_REFUND_FULL_ORDER_RBI,
  DECISION_NODE_ACTIONS.RBI_ISSUE_COUPON_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.RBI_ISSUE_COUPON_AND_REFUND_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.RBI_ISSUE_LOYALTY_POINTS_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.RBI_ISSUE_LOYALTY_POINTS_AND_REFUND_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.RBI_UPDATE_CUSTOMER_BIRTHDAY_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.REFUND_SHIPPING_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.REINSTATE_ACCOUNT_THEN_SEND_MACRO,
  DECISION_NODE_ACTIONS.SEND_CUSTOMER_PASSWORD_RESET,
];

export const DECISION_NODE_PROCESSING_ACTIONS = {
  CANCELLATION_PROCESSING: 'CANCELLATION_PROCESSING',
  CANCEL_AND_REFUND_PROCESSING: 'CANCEL_AND_REFUND_PROCESSING',
  REFUND_PROCESSING: 'REFUND_PROCESSING',
  CANCEL_AND_REFUND_OR_DISCOUNT_PROCESSING: 'CANCEL_AND_REFUND_OR_DISCOUNT_PROCESSING',
  DISCOUNT_PROCESSING: 'DISCOUNT_PROCESSING',
  CANCELLATION_OR_DISCOUNT_PROCESSING: 'CANCELLATION_OR_DISCOUNT_PROCESSING',
  CHECK_RBI_REMEDIATIONS: 'CHECK_RBI_REMEDIATIONS',
};

export const DECISION_NODE_INFO_WIDGETS = {
  CUSTOM_WIDGET: 'CUSTOM_WIDGET',
  SUBSCRIPTION_DETAILS: 'SUBSCRIPTION_DETAILS',
  ORDER_STATUS_LINE_ITEM_DETAILS: 'ORDER_STATUS_LINE_ITEM_DETAILS',
  RETURNED_ITEM_DETAILS: 'RETURNED_ITEM_DETAILS',
  CANCELED_ITEM_DETAILS: 'CANCELED_ITEM_DETAILS',
  CANCEL_AND_REFUND_INFO: 'CANCEL_AND_REFUND_INFO',
  PARTIAL_REFUND_ITEM_DETAILS: 'PARTIAL_REFUND_ITEM_DETAILS',
  AMAZON_ORDER_INFO: 'AMAZON_ORDER_INFO',
  RETURN_PORTAL_INFO: 'RETURN_PORTAL_INFO',
  RBI_ORDER_REFUND_INFO: 'RBI_ORDER_REFUND_INFO',
  RBI_REFUNDED_ORDER_INFO: 'RBI_REFUNDED_ORDER_INFO',
  RBI_COUPON_INFO: 'RBI_COUPON_INFO',
  RBI_SELECTED_STORE_DETAILS: 'RBI_SELECTED_STORE_DETAILS',
  SALESFORCE_ORDER_INFO: 'SALESFORCE_ORDER_INFO',
  RBI_POINTS_INFO: 'RBI_POINTS_INFO',
  RBI_GIFT_CARD_INFO: 'RBI_GIFT_CARD_INFO',
  RBI_OFFERS_INFO: 'RBI_OFFERS_INFO',
  REFUND_SHIPPING_THEN_SEND_MACRO: 'REFUND_SHIPPING_THEN_SEND_MACRO',
  RBI_RUTR_EVENTS_INFO: 'RBI_RUTR_EVENTS_INFO',
  REVOLVE_ORDER_DETAILS: 'REVOLVE_ORDER_DETAILS',
  REVOLVE_CANCEL_ORDER_INFO: 'REVOLVE_CANCEL_ORDER_INFO',
  PREVIOUS_REFUNDS: 'PREVIOUS_REFUNDS',
  TICKET_FIELDS_WIDGET: 'TICKET_FIELDS_WIDGET',
  ORDER_ADDRESS_INFO_WIDGET: 'ORDER_ADDRESS_INFO_WIDGET',
  RBI_REMEDIATIONS_WIDGET: 'RBI_REMEDIATIONS_WIDGET',
  CUSTOMER_DETAILS_FOR_ITEM_REPLACEMENT_WIDGET: 'CUSTOMER_DETAILS_FOR_ITEM_REPLACEMENT_WIDGET',
  CUSTOMER_PROFILE_NOTES_WIDGET: 'CUSTOMER_PROFILE_NOTES_WIDGET',
  HOCKEY_CHALLENGE_WIDGET: 'HOCKEY_CHALLENGE_WIDGET',
  RBI_CHALLENGE_WIDGET: 'RBI_CHALLENGE_WIDGET',
};

export const CHOOSE_SUB_TOKENS = [
  {
    PREPAID: 'prepaid',
    PAY_AS_YOU_GO: 'pay_as_you_go',
  },
  {
    CANCELLED: 'cancelled',
    ACTIVE: 'active',
    CLOSED: 'closed',
    EXPIRED: 'expired',
    // Manscaped client uses status INACTIVE for cancelled
    INACTIVE: 'cancelled',
  },
  {
    CURRENT_ORDER_FULFILLED: 'current_order_fulfilled',
    CURRENT_ORDER_UNFULFILLED: 'current_order_unfulfilled',
  },
  // Not needed until we figure out the null shipment_status from shopify
  // {
  //   IN_TRANSIT: 'in_transit',
  //   PRE_TRANSIT: 'pre_transit',
  //   DELIVERED: 'delivered'
  // }
];

// TODO: consider making tree data structure to prevent combinations that are impossible (e.g. item_unfulfilled with has_tracking)
export const LINE_ITEM_ORDER_STATUS_TOKENS = [
  {
    ORDER_REFUNDED: 'order_refunded',
    ITEM_UNFULFILLED: 'item_unfulfilled',
    ITEM_FULFILLED: 'item_fulfilled',
  },
  {
    HAS_SHIPPING_DATE: 'has_shipping_date',
    NO_SHIPPING_DATE: 'no_shipping_date',
    HAS_TRACKING: 'has_tracking',
    NO_TRACKING: 'no_tracking',
  },
  {
    RECENT_ORDER: 'recent_order',
    OLD_ORDER: 'old_order',
    TRANSIT: 'in_transit', // mapping is different b/c shippo uses transit instead of in_transit
    PRE_TRANSIT: 'pre_transit',
    DELIVERED: 'delivered',
    NO_LONGER_STORED: 'no_longer_stored',
    UNSUPPORTED_CARRIER: 'unsupported_carrier',
  },
  {
    STUCK: 'stuck',
    NORMAL: 'normal',
    OLD: 'old',
    RECENT: 'recent',
    UPS_SUREPOST: 'ups_surepost',
  },
];

export const ITEMS_COMPLETE = 'items_complete';

// number of days
export const RECENT_ORDER_THRESHOLD = 7;
export const RECENT_DELIVERY_THRESHOLD = 3;
export const STUCK_IN_TRANSIT_THRESHOLD = 4;
export const USPS_STORAGE_THRESHOLD = 120;

export const RETURN_REFUND_STATUS_TOKENS = {
  HAS_SHIPPING_LABEL_LINK: 'has_shipping_label_link',
  NO_SHIPPING_LABEL_LINK: 'no_shipping_label_link',
  MORE_THAN_ONE_RETURN: 'more_than_one_return',
  NO_RMA: 'no_rma',
  ITEM_HAS_BEEN_RETURNED: 'item_has_been_returned',
  TRACKING_LINK_FAILED: 'tracking_link_failed',
  UNRECOGNIZED_CARRIER: 'unrecognized_carrier',
  INVALID_STATUS: 'invalid_status',
  ALREADY_REFUNDED: 'already_refunded',
  FOUR_OR_MORE_UNRETURNED: 'four_or_more_unreturned',
};

export const STORE_CREDIT_STATUS_TOKENS = {
  FOUR_OR_MORE_ITEMS_CANCELED_OR_PREVIOUS_CANCELLATIONS: 'four_or_more_items_canceled_or_previous_cancellations',
  TWO_OR_THREE_ITEMS_CANCELED: 'two_or_three_items_canceled',
  ONE_ITEM_CANCELED: 'one_item_canceled',
  SELECTED_ORDER_NOT_CANCELED: 'selected_order_not_canceled',
};

export const QUICK_ACTIONS = {
  CANCEL_AMAZON_ORDER: 'CANCEL_AMAZON_ORDER', // finds the order # in the conversation, fetches adn process order data then push to the final edge. Works for Asurion cancellation tree
};

export const RBI_DECISION_EDGES = {
  ORDER_ALREADY_REFUNDED: 'order_already_refunded',
  FRAUD_ALERT: 'fraud_alert',
  PAYMENT_ERROR: 'payment_error',
  REFUND_ERROR: 'refund_error',
  REFUND_AMOUNT_LIMIT_EXCEEDED: 'refund_amount_limit_exceeded',
  MAX_REFUNDS_COUNT_LIMIT_EXCEEDED: 'max_refunds_count_limit_exceeded',
  FREE_AND_PAID_ITEMS_SELECTED: 'free_and_paid_items_selected',
  FREE_ITEM_SELECTED: 'free_item_selected',
  ORDER_VALID_FOR_REFUND: 'order_valid_for_refund',
  NO_SEARCH_RESULTS: 'no_search_results',
  EXISITNG_ACCOUNT_NO_ORDERS: 'exisitng_account_no_orders',
  REFUND_PERCENTAGE_THRESHOLD_EXCEEDED: 'refund_percentage_threshold_exceeded',
  ORDER_HAS_REMEDIATIONS: 'order_has_remediations',
};

export const CUSTOM_INFO_WIDGET_ORDER_FIELDS = {
  SHIPPING_AMOUNT: 'shippingAmount',
  TOTAL_PRICE_OF_ITEMS: 'totalPriceOfItems',
};

export const CANCEL_AND_REFUND_OR_DISCOUNT_DECISION_EDGES = {
  ORDER_IS_SUBSCRIPTION: 'order_is_subscription',
  ORDER_IS_ALREADY_REFUNDED: 'order_is_already_refunded',
  ORDER_IS_ALREADY_CANCELED: 'order_is_already_canceled',
  INVALID_ENTIRELY_FULFILLED: 'invalid_entirely_fulfilled',
  REFUND_AMOUNT_LIMIT_EXCEEDED: 'refund_amount_limit_exceeded',
  VALID_ITEMS_EXIST: 'valid_items_exist',
  NO_VALID_ITEMS_EXIST: 'no_valid_items_exist',
};

export const PARTIAL_REFUND_DECISION_EDGES = {
  ITEMS_ALREADY_REFUNDED: 'items_already_refunded',
  REFUND_LAGER_THAN_TOTAL_PAID: 'refund_larger_than_total_paid',
  REFUND_AMOUNT_LIMIT_EXCEEDED: 'refund_amount_limit_exceeded',
  NO_ITEMS_SELECTED: 'no_items_selected',
  ORDER_IS_SUBSCRIPTION: 'order_is_subscription',
  ALL_VALID_ITEMS: 'all_valid_items',
};

export const SELECT_CUSTOMER_TO_REINSTATE_ACCOUNT_EDGES = {
  NO_CUSTOMER_OR_ACCOUNT_FOUND: 'no_customer_or_account_found',
  ACCOUNT_VALID_FOR_REINSTATEMENT: 'account_valid_for_reinstatement',
  NOT_IN_DETENTION: 'not_in_detention',
  CANNOT_BE_REINSTATED: 'cannot_be_reinstated',
};

export const REFUND_AMOUNT_TYPE = {
  DOLLAR_AMOUNT: 'DOLLAR_AMOUNT',
  PERCENT: 'PERCENT',
};

export const CANCEL_ACTIONS = {
  REFUND: 'REFUND',
  CANCEL: 'CANCEL',
  STORECREDIT: 'STORECREDIT',
  REPLACE: 'REPLACE',
};

export const CANCEL_TYPES = {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
};

export const RETURN_TYPES = { ...CANCEL_TYPES };

export const REASON_TYPES = {
  CANCEL_AND_REFUND: 'CANCEL_AND_REFUND',
  REFUND: 'REFUND',
  REPLACE: 'REPLACE',
};

export const reasonTypesReadableMap = {
  [REASON_TYPES.CANCEL_AND_REFUND]: 'cancel and refund',
  [REASON_TYPES.REFUND]: 'refund',
  [REASON_TYPES.REPLACE]: 'replace',
};

export const CANCEL_SUBSCRIPTION_ERROR_MESSAGE =
  'There was an error when attempting to cancel the subscription. Please try again in 5 minutes or escalate with the comment "Cannot cancel subscription."';

export const TIME_UNITS = ['MINUTES', 'HOURS', 'DAYS', 'WEEKS', 'MONTHS', 'YEARS'];
